import { Combobox, CustomTable, generateGenericComboDTO, GetItemsProps } from "medere-ui-framework"
import { getAllOrders, getAllOrdersItems, getAllOrdersTaxes } from "../servicesHooks/OrderOfProvision/useOrderOfProvisionService"
import { useEffect, useId, useRef, useState } from "react"
import { Column } from "primereact/column"
import { Button } from "primereact/button"
import OrderOfProvision from "./OrderOfProvision/OrderOfProvision"
import { format } from "date-fns"
import { getLastAccountingPeriod } from "../servicesHooks/Accounting/useAccountingService"
import { AccountingPeriod, AdministrativeForm } from "../interface/interface"
import { Toast } from "primereact/toast"
import { showMessage } from "../utils/messages"
import Big from "big.js"
import { EditOrder, ETaxes, ItemVaucher, TaxType } from "../interface/orderOfProvision"
import { getStringEnumValueByIdEnum } from "../utils/utils"
import { EAdministrativeFormTypeValues } from "../enums/EAdministrativeFormType"
import { GenericComboDTO } from "medere-ui-framework"
import { useSearchParams } from 'react-router';
import { DataTableValueArray } from "primereact/datatable"
import { useSupplierService } from "../servicesHooks/Supplier/useSupplierService"

function EditOrderOfProvision() {
    const { getAllSuppliersCombo } = useSupplierService();
    const idTable = useId()
    const [searchParams] = useSearchParams();
    const [selectedOrder, setSelectedOrder] = useState<DataTableValueArray | null>(null)
    const [selectedSupplier, setSelectedSupplier] = useState<any>()
    const [orderProvision, setOrderProvision] = useState<EditOrder | null>({
        netTaxed: Big(0),
        noTaxed: Big(0),
        exempt: Big(0),
        iva: Big(0),
        percIva: Big(0),
        iibb: Big(0),
        others: Big(0),
        total: Big(0),
        items: [],
        taxes: [],
        reicipt: null,
        orderDate: null,
        accountDate: null,
        expirationDate: null,
        pos: null,
        voucherNumber: null,
        payWithCreditCard: false,
        operationWithSGR: false,
        description: '',
        supplier: null,
    })
    const [lastAccountingPeriod, setLastAccountingPeriod] = useState<AccountingPeriod | null>(null)
    const toastRef = useRef(null)

    useEffect(() => {
        getLastAccountingPeriod({ offset: 0, pageSize: 50 })
            .then(res => setLastAccountingPeriod(res))
    }, [])

    useEffect(() => {

        async function convertToOrderInfo() {
            if (!selectedOrder) {
                showMessage(toastRef, 'Se produjo un error, intente nuevamente', 'error')
                return
            }
            try {
                const order = selectedOrder[0]

                const respItems = await getAllOrdersItems(0, 0, { administrativeForm: order?.administrativeform })
                const _items: ItemVaucher[] = respItems.map((item) => {
                    return {
                        id: item.administrativeformitem.toString(),
                        description: item.description,
                        amount: Big(item.unitprice),
                        account: {
                            alias: '',
                            level: '',
                            accounting: 0,
                            identifier: '',
                            parentaccountingaccountpk: 0,
                            allowsmovements: false,
                            accountingaccount: item.accountingaccount,
                            description: item.accountingaccountdesc,
                            fulldescription: item.accountingaccountdesc,
                        },
                        total: Big(item.totalamount),
                        taxAmount: Big(item.vatamount),
                        tax: {
                            taxtype: item.taxtype,
                            taxname: item.taxname,
                            taxvalue: item.taxvalue,
                            exempttype: item.exempttype,
                            accounting: 0,
                            forpaymentsfromothers: false,
                            forpaymentstoothers: false,
                            forpurchaseinvoices: false,
                            forsalesinvoices: false,
                            externalid: 0,
                            iibb: false,
                            vatperception: false,
                            vattax: false,
                            taxaccountdesc: '',
                            taxaccountidentifier: '',
                            taxaccount: 0,
                        }
                    }
                })
                let _taxes: TaxType[] = []
                const respTaxes = await getAllOrdersTaxes(0, 0, { administrativeForm: order.administrativeform })
                _taxes = respTaxes?.map((tax) => {
                    return {
                        visible: true,
                        editable: true,
                        taxAccount: tax.taxaccount,
                        taxAccountDesc: tax.taxaccountdesc,
                        taxAccountIdentifier: tax.taxaccountalias,
                        taxName: tax.taxname,
                        taxValue: tax.taxamount,
                        taxType: tax.taxtype,
                        exemptVatTax: tax.exemptvattax,
                        vatNotTaxed: tax.vatnottaxed
                    }
                })
                const _reicipt: GenericComboDTO | null = generateGenericComboDTO(order.administrativeformtype, getStringEnumValueByIdEnum(order.administrativeformtype, EAdministrativeFormTypeValues))
                if (_reicipt) {
                    (_reicipt as any).shortdescription = _reicipt.description;
                }
                // const {netamount} = order
                console.log(_taxes)
                const iibb = _taxes.find(tax => tax.taxType == ETaxes.INGRESOS_BRUTOS)
                const _orderProvision: EditOrder = {
                    netTaxed: Big(order.netamount),
                    noTaxed: Big(order.netamountnottaxed),
                    exempt: Big(order.exemptamount),
                    iva: Big(order.vatamount),
                    percIva: Big(order.taxesamount),
                    iibb: Big(iibb?.taxValue ?? 0),
                    others: Big(0),
                    total: Big(order.amount),
                    items: _items,
                    taxes: _taxes,
                    reicipt: null,
                    orderDate: new Date(order.date),
                    accountDate: new Date(order.accountdate),
                    expirationDate: new Date(order.expirationdate),
                    pos: order.posnumber,
                    voucherNumber: order.formnumber,
                    payWithCreditCard: false,
                    operationWithSGR: false,
                    // ? Falta agregar la forma de poder abrir el comprobante de compra desde otras views, para poder editar el comprobante
                    supplier: null,
                    description: order.description,
                }
                console.log(order)
                setOrderProvision(_orderProvision)
            } catch (e) {
                console.error(e)
                showMessage(toastRef, 'Se produjo un error, intente nuevamente', 'error')
                return
            }

        }

        if (selectedOrder != null) {
            convertToOrderInfo()
        } else {
            setOrderProvision(null)
        }
    }, [selectedOrder])

    function handleClick() {
        if (selectedSupplier == null) {
            showMessage(toastRef, 'Debe seleccionar un proveedor antes de modificar un comprobante', 'error')
            return
        }
        let _closingdate = new Date(lastAccountingPeriod ? lastAccountingPeriod?.closingdate : "")
        if (selectedOrder == null)
            return
        let _accountdate = new Date(selectedOrder[0].accountdate)
        if (lastAccountingPeriod == null || _closingdate < _accountdate) {
            // setOrderModal(true)
        } else {
            showMessage(toastRef, 'No puede modificar un comprobante que está dentro del cierre del mes', 'error')
        }

    }

    return (
        <div className="min-h-screen p-4 flex flex-column">
            <h2 className="textBold text-2xl">Comprobante de Compra</h2>
            <div className="flex justify-content-between align-items-end">
                <Combobox
                    width="25"
                    label="Proveedores"
                    value={selectedSupplier}
                    setValue={setSelectedSupplier}
                    optionLabel="businessname"
                    getItems={(getItemsProps: GetItemsProps) => {
                        return getAllSuppliersCombo(getItemsProps)
                    }}
                />
                <Button icon='pi pi-pencil' className="buttonMain" disabled={!selectedOrder} onClick={handleClick} />
            </div>

            {selectedSupplier && selectedOrder && <OrderOfProvision
            />}

            <CustomTable
                idTable={idTable}
                filterRow
                getItems={getAllOrders}
                params={{
                    supplierId: selectedSupplier?.medereentity,
                }}
                selectionMode="single"
                selectedItems={selectedOrder ?? []}
                onSelectionChange={(e) => {
                    if (e.value == null) {
                        setSelectedOrder(null)
                        return
                    }
                    setSelectedOrder([e.value])
                }}
                showGridlines
            >
                <Column field="date" header="Fecha" body={(e) => {
                    return format(new Date(e.date), 'dd/MM/yyyy')
                }} />
                <Column field="posnumber" header="PV" />
                <Column field="formnumber" header="Comprobante" />
                <Column field="billingname" header="Proveedor" />
                <Column field="amount" header="Total" />
            </CustomTable>
            <Toast ref={toastRef} position='bottom-right' />
        </div>
    )
}

export default EditOrderOfProvision
